function setFormSubmitting({ state }) {
  state.set('client.forms.isSubmitting', true)
}

export default setFormSubmitting



// WEBPACK FOOTER //
// ./src/modules/user/actions/setFormSubmitting.js